// extracted by mini-css-extract-plugin
export default {"radioGroupContainer":"DocumentsList_radioGroupContainer__Hpoqp"};